import React from 'react';
import styles from './ConfirmationModal.module.scss';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';

export type confirmationModal = {
  visibility: boolean;
  setShow: any;
  removeEntry: any;
};

const ConfirmationModal = ({ visibility, setShow, removeEntry }: confirmationModal) => {
  const handleClose = () => setShow(false);
  return (
    <div className={styles.ConfirmationModal} data-testid="ConfirmationModal">
      <Modal show={visibility}>
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>
            Delete Entry
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure want to delete this entry?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type='button'
            variant="danger"
            size={'sm'}
            onClick={() => removeEntry()}
          >
            Delete
          </Button>
          <Button
            type='button'
            variant="outline-secondary"
            size={'sm'}
            onClick={() => setShow(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
